import React from 'react'
import styled from 'styled-components'

import MetricsTable from './MetricsTable'
import AddButton from 'components/AddButton'

import { useStoreContext } from 'hooks/StoreContext'
import useDeviceMetrics from 'hooks/useDeviceMetrics'

import { screenSize, LoadingSinglePanePage } from 'styles/shared'
interface CallToAction {
  details: string[]
  description: string
}
export interface Metric {
  id: string
  name: string
  description: string
  callToAction: CallToAction[]
  color: string
  unit: string
  draft: boolean
  charts: string[]
  hasMetricValues: boolean
}

const Metrics = () => {
  useDeviceMetrics()

  const { deviceMetrics, areDeviceMetricsLoaded } = useStoreContext()

  if (!areDeviceMetricsLoaded) {
    return <LoadingSinglePanePage />
  }

  return (
    <>
      <S.Header>
        <AddButton uri="/admin/metrics/new" testId="Add Metric">Add Metric</AddButton>
      </S.Header>
      <MetricsTable deviceMetrics={deviceMetrics} />
    </>
  )
}

const S = {
  Header: styled.div`
    display: flex;
    justify-content: end;
    padding-bottom: 5px;
    margin: 15px 20px 5px 0;

    @media ${screenSize.small} {
      justify-content: end;
    }
  `
}

export default Metrics
